//这里是 车间工时管理 模块的路由文件

const basePath = "/admin/workshop/";
export default [
    //全部工作计划
    {
        path: `${basePath}allplan`,
        name: 'DailyAllPlan',
        component: r => require.ensure([], () => r(require('@/views/workshop/DailyAllPlan')), 'Daily')
    },
    //工作计划
    {
        path: `${basePath}plan`,
        name: 'WorkPlan',
        component: r => require.ensure([], () => r(require('@/views/workshop/WorkPlan')), 'Workshop')
    },
    //工作计划 -> 项目详情
    {
        path: `${basePath}plan/des`,
        name: 'WorkPlanDescription',
        component: r => require.ensure([], () => r(require('@/views/workshop/component/PlanComponent')), 'Workshop')
    },
    //日报管理
    {
        path: `${basePath}report`,
        name: 'DailyReport',
        component: r => require.ensure([], () => r(require('@/views/workshop/DailyReport')), 'Workshop')
    },
    //我的日报
    {
        path: `${basePath}me`,
        name: 'DailyMe',
        component: r => require.ensure([], () => r(require('@/views/workshop/DailyMe')), 'Workshop')
    },
    //工时统计
    {
        path: `${basePath}total`,
        name: 'DailyTotal',
        component: r => require.ensure([], () => r(require('@/views/workshop/DailyTotal')), 'Workshop')
    },
    //工时统计 => 查看
    {
        path: `${basePath}total/des`,
        name: 'TotalDescription',
        component: r => require.ensure([], () => r(require('@/views/workshop/component/TotalDescription')), 'Workshop')
    },
    //订单工序管理
    {
        path: `${basePath}order`,
        name: 'WorkshopOrder',
        component: r => require.ensure([], () => r(require('@/views/workshop/WorkshopOrder')), 'Workshop')
    },
    //工序模版
    {
        path: `${basePath}processTemplate`,
        name: 'ProcessTemplate',
        component: r => require.ensure([], () => r(require('@/views/workshop/ProcessTemplate.vue')), 'Workshop')
    },
    {
        path: `${basePath}unitBind`,
        name: 'UnitBind',
        component: r => require.ensure([], () => r(require('@/views/workshop/UnitBind.vue')), 'Workshop')
    }
]
